import { Logo } from "../../assets/images";
import { Link } from "react-router-dom";
import { Button, Input } from "../atoms/common";
import { useState } from "react";
import { GlobalPost } from "../../helpers/fetcher";
import alertMessage from "../../helpers/alertMessage";
import Environtment from "../../constant/environtment.json";
import { ImLinkedin2, ImYoutube, ImFacebook } from "react-icons/im";
import { FaInstagram } from "react-icons/fa";

const FooterLanding = () => {
  const { REACT_APP_API_URL } = Environtment;
  const [email, setEmail] = useState("");
  const [loading, setLoading] = useState(false);

  const newSubscriber = async (e) => {
    e.preventDefault();
    setLoading(true);
    try {
      const response = await GlobalPost({
        url: `${REACT_APP_API_URL}subscriber`,
        data: { email: email },
      });
      if (response?.status === 201) {
        setLoading(false);
        alertMessage(
          "success",
          response?.message,
          "Ok",
          window.location.reload()
        );
      } else {
        setLoading(false);
        alertMessage("error", response?.message, "Retry", () => {});
      }
    } catch (err) {
      setLoading(false);
      alertMessage("error", err, "Retry", () => {});
    }
  };
  return (
    <footer className="bg-gray2 flex-col tablet:block w-full bg-no-repeat bg-cover px-8 pt-20 pb-5 text-white font-inter">
      <div className="flex tablet:flex-col w-full pb-20 border-b border-gray-500">
        <div className="w-1/3 mr-4 tablet:w-full mt-[-7px]">
          <img src={Logo} alt="Sagara Group Technology" />
        </div>
        <div className="w-1/3 tablet:w-full pl-[0px] lg:pl-[3rem] desktop:mt-0">
          <h3 className="mx-auto font-semibold text-lg">Service</h3>
          <ul className="mt-6">
            <Link to="/" className="w-1/2 mb-3 hover:text-greenWebsite">
              <li className="my-4">Development Team</li>
            </Link>
            <Link to="/" className="w-1/2 mb-3 hover:text-greenWebsite">
              <li className="my-4">Mobile app</li>
            </Link>
            <Link to="/" className="w-1/2 mb-3 hover:text-greenWebsite">
              <li className="my-4">Enterprise software</li>
            </Link>
            <Link to="/" className="w-1/2 mb-3 hover:text-greenWebsite">
              <li className="my-4">DevOps</li>
            </Link>
          </ul>
        </div>
        <div className="w-1/3 tablet:w-full lg:pl-[3rem]">
          <h3 className="mx-auto font-semibold text-lg ">Company</h3>
          <ul className="mt-6">
            <Link to="/" className="w-1/2 mb-3 hover:text-greenWebsite">
              <li className="my-4">About</li>
            </Link>
            <Link to="/" className="w-1/2 mb-3 hover:text-greenWebsite">
              <li className="my-4">Our work</li>
            </Link>
            <Link to="/" className="w-1/2 mb-3 hover:text-greenWebsite">
              <li className="my-4">News</li>
            </Link>
            <Link to="/" className="w-1/2 mb-3 hover:text-greenWebsite">
              <li className="my-4">Career</li>
            </Link>
          </ul>
        </div>
        <div className="w-1/3 tablet:w-full lg:pl-[3rem]">
          <h3 className="mx-auto font-semibold text-lg">Let's connect</h3>
          <ul className="mt-6">
            <a
              href="https://www.linkedin.com"
              className="hover:text-greenWebsite"
              rel="noreferrer"
              target="_blank"
            >
              <li className="my-4 flex">
                <ImLinkedin2 className="mr-2" size={20} />
                <span>Linkedin</span>
              </li>
            </a>
            <a
              href="https://www.youtube.com"
              className="hover:text-greenWebsite"
              rel="noreferrer"
              target="_blank"
            >
              <li className="my-4 flex">
                <ImYoutube className="mr-2" size={20} />
                <span>Youtube</span>
              </li>
            </a>
            <a
              href="https://www.facebook.com"
              className="hover:text-greenWebsite"
              rel="noreferrer"
              target="_blank"
            >
              <li className="my-4 flex">
                <ImFacebook className="mr-2" size={20} />
                <span>Facebook</span>
              </li>
            </a>
            <a
              href="https://www.instagram.com"
              className="hover:text-greenWebsite"
              rel="noreferrer"
              target="_blank"
            >
              <li className="my-4 flex">
                <FaInstagram className="mr-2" size={20} />
                <span>Instagram</span>
              </li>
            </a>
          </ul>
        </div>
        <form
          className="w-[70%] tablet:w-full flex lg:px-5 flex-col"
          onSubmit={newSubscriber}
        >
          <label className="text-xl font-bold mb-5  ">
            Subscribe our Insights
          </label>
          <div className="flex w-full">
            <Input
              classes="px-2 py-1 w-full bg-white mr-2"
              inputClasses={
                "outline-none border-0 focus:ring-0 w-full text-dark"
              }
              value={email}
              required
              handler={(e) => setEmail(e)}
            />
            <Button
              classes={
                "rounded-full bg-greenWebsite text-white px-2 py-1 ml-2 text-xs"
              }
              text={loading ? "Loading..." : "SUBSCRIBE"}
              disabled={loading}
              type="submit"
            />
          </div>
          <p className="text-xs mt-5 text-justify">
            Sagara Group is one of the world’s leading high-growth alternative
            investment firms that creates lasting impact for our investors,
            teams, businesses, and the communities in which we live. With
            offices on five continents, our global team aligns our interests
            with those of our investors for lasting impacts.
          </p>
        </form>
      </div>
      <div className="flex tablet:flex-col justify-between py-4 h-fit text-sm">
        <div className="text-gray-500 flex">
          <span className="mr-3">
            ©2021 Sagara Group, Inc. All rights reserved.
          </span>
          <span className="mr-3">Privacy Policy</span>
          <span className="mr-3">Term Of Service</span>
        </div>
        <div className="flex">
          <span className="text-gray-500 flex">Our Offices:</span>
          <span className="text-greenWebsite ml-2">
            New York, Boston, London, Jakarta, Lagos, Sydney
          </span>
        </div>
      </div>
    </footer>
  );
};

export default FooterLanding;
